import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Download, ShieldCheck } from 'lucide-react';
export function OfferBlock() {
  return <div id="oferta" className="bg-[#0D5C63] text-[#FFF8F0]" data-id="element-101">
      <Section data-id="element-102">
        <div className="max-w-4xl mx-auto text-center" data-id="element-103">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6" data-id="element-104">
            Todo digital instantáneo: eBook + bonuses
          </h2>

          <p className="text-xl mb-12 opacity-90" data-id="element-105">
            Descarga ya, empieza 6am mañana post-ducha.
          </p>

          <div className="bg-[#0A4A50] p-8 md:p-12 rounded-3xl border-2 border-[#C9A84C] max-w-2xl mx-auto relative overflow-hidden" data-id="element-106">
            {/* Badge */}
            <div className="absolute top-0 right-0 bg-[#C9A84C] text-[#2D2D2D] px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-107">
              OFERTA LIMITADA
            </div>

            <div className="flex flex-col items-center" data-id="element-108">
              <span className="text-6xl md:text-7xl font-bold text-[#C9A84C] mb-2 font-serif" data-id="element-109">
                $9.99
              </span>
              <span className="text-sm text-gray-300 mb-8 line-through" data-id="element-110">
                $47 Precio Regular
              </span>

              <Button fullWidth className="text-lg md:text-xl py-5 mb-4 shadow-[0_0_20px_rgba(201,168,76,0.3)]" onClick={() => window.open('https://coreeveryday.com/cart/48302469382363:1', '_blank')} data-id="element-111">
                COMPRAR AHORA POR $9.99
              </Button>

              <div className="flex items-center justify-center text-sm text-gray-300 gap-4 mt-4" data-id="element-112">
                <span className="flex items-center" data-id="element-113">
                  <Download className="w-4 h-4 mr-1" data-id="element-114" /> Descarga Instantánea
                </span>
                <span className="flex items-center" data-id="element-115">
                  <ShieldCheck className="w-4 h-4 mr-1" data-id="element-116" /> Pago Seguro
                </span>
              </div>

              <p className="mt-6 text-sm text-[#C9A84C] italic" data-id="element-117">
                Descarga instantánea — espejo día 7 cambia
              </p>
            </div>
          </div>

          <p className="mt-8 text-xs text-gray-400" data-id="element-118">
            Descarga vía Shopify/Stan Store. Formato PDF compatible con todos
            los dispositivos.
          </p>
        </div>
      </Section>
    </div>;
}